<template>
    <div class="x_app">
        <div class="x_body">
            <div class="card x_card no-bor">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <div>
                                    <input type="text" class="form-control form-control-sm" placeholder="Search..." />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="row">
                                <div v-for="(ret,index) in records" class="col-xs-12 col-sm-12 col-md-6 col-lg-4" :key="index">
                                    <router-link :to="ret.Url" class="list-group-item-menu">
                                        <i :class="ret.Icon" aria-hidden="true"></i>
                                        <span>{{ret.Name}}</span>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            records: [
                {
                    Name: this.$t('company'),
                    Url: '/setting/company',
                    Icon: 'fa fa-bandcamp'
                },
                {
                    Name: this.$t('category'),
                    Url: '/setting/category',
                    Icon: 'fa fa-bullhorn'
                },
                {
                    Name: this.$t('branch'),
                    Url: '/setting/branches',
                    Icon: 'fa fa-snowflake-o'
                },
                {
                    Name:this.$t('uom'),
                    Url: '/setting/uoms',
                    Icon: 'fa fa-desktop'
                },
                {
                    Name: this.$t('bank'),
                    Url: '/setting/banks',
                    Icon: 'fa fa-diamond'
                },
                {
                    Name: this.$t('public_holiday'),
                    Url: '/setting/holiday',
                    Icon: 'fa fa-eye'
                },
                {
                    Name: this.$t('brand'),
                    Url: '/setting/brands',
                    Icon: 'fa fa-database'
                },
                {
                    Name: this.$t('exchange_rate'),
                    Url: '/setting/exchangerates',
                    Icon: 'fa fa-life-ring'
                },
                {
                    Name: this.$t('payment_method'),
                    Url: '/setting/payment-method',
                    Icon: 'fa fa-credit-card'
                },
                {
                    Name: this.$t('config_number'),
                    Url: '/setting/config-number',
                    Icon: 'fa fa-cubes'
                }
            ]
        }
    },
    created(){

    }
}
</script>
<style scoped>
    .list-group-item-menu{
        text-decoration: none;
        padding: 8px;
        background: #fff;
        border-radius: 3px;
        border: 1px dashed #ddd;
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 8px;
    }
    .list-group-item-menu:hover{
        background: green;
        color: #fff;
    }
</style>